export const buildBuyLink = (
  chainId?: number | string,
  tokenAddress?: string,
  versionType?: string
) => {
  const params = new URLSearchParams()
  if (chainId !== undefined && chainId !== null && chainId !== '') {
    params.set('chain', String(chainId))
  }
  if (tokenAddress) {
    params.set('address', tokenAddress)
  }
  if (versionType) {
    params.set('version', String(versionType).toLowerCase())
  }
  const query = params.toString()
  return query ? `/buy/?${query}` : '/buy/'
}

export default buildBuyLink
